<template>
  <div class="history-search-bar">
    <el-form :model="searchForm" label-position="top">
      <el-row :gutter="20">
        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('PartnerManagement.applyTime')">
            <el-date-picker v-model="searchForm.applyTime" type="datetimerange" :clearable="true"
                            :start-placeholder="$t('PartnerManagement.startDatePlaceholder')"
                            :end-placeholder="$t('PartnerManagement.endDatePlaceholder')"/>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('PartnerManagement.contactName')">
            <el-input v-model="searchForm.contactName" filterable
                      :placeholder="$t('PartnerManagement.contactNamePlaceholder')" :clearable="true"
                      class="custom-tree-select-width"/>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('PartnerManagement.storeName')">
            <el-input v-model="searchForm.storeName" filterable
                      :placeholder="$t('PartnerManagement.storeNamePlaceholder')" :clearable="true"
                      class="custom-tree-select-width"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('PartnerManagement.country')">
            <el-select v-model="searchForm.country" multiple filterable
                       collapse-tags collapse-tags-tooltip
                       :placeholder="$t('PartnerManagement.countryPlaceholder')" :clearable="true"
                       class="custom-tree-select-width">
              <el-option v-for="country in countryOptions" :key="country.code"
                         :label="country.label" :value="country.code"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12" :md="5" :lg="5">
          <el-form-item label="&nbsp;">
            <el-button class="button-background-color" @click="search">
              {{ $t('PartnerManagement.search') }}
            </el-button>
            <el-button @click="reset" class="custom-reset-button">
              {{ $t('PartnerManagement.reset') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import dialogMixin from "@/mixins/dialogMixin";
import countryMixin from "@/mixins/countryMixin";

export default {
  data() {
    return {
      searchForm: {
        applyTime: '',
        contactName: '',
        storeName: '',
        country: [],
      },
    };
  },
  mixins: [dialogMixin, countryMixin],
  mounted() {
    this.fetchCountryOptions();
  },

  methods: {
    search() {
      let searchCondition = {};

      if (this.searchForm.applyTime && this.searchForm.applyTime.length === 2) {
        const [start, end] = this.searchForm.applyTime;
        searchCondition["apply_time-begin"] = this.formatDate(null, null, start);
        searchCondition["apply_time-end"] = this.formatDate(null, null, end);
      }

      if (this.searchForm.contactName) {
        searchCondition["contact_name-like"] = this.searchForm.contactName;
      }

      if (this.searchForm.storeName) {
        searchCondition["store_name-like"] = this.searchForm.storeName;
      }

      if (this.searchForm.country && this.searchForm.country.length > 0) {
        searchCondition["country-in"] = this.searchForm.country;
      }

      this.$emit('search', searchCondition);
    },
    reset() {
      this.searchForm = {
        applyTime: '',
        contactName: '',
        storeName: '',
        country: [],
      };
      this.search();
    }
  },
};
</script>
<style scoped>
</style>
